import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
//import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollToPlugin,ScrollTrigger);

//オープニング動画再生

(() => {
    window.addEventListener('load',() => {
        const title = document.querySelectorAll('.js-hero-title');
        const inner = document.querySelectorAll('.js-hero-title-mask');

        title.forEach((element,index) => {
            gsap.to(element,{
                scaleX: 1,
                duration: 0.5,
                delay: index * 0.2,
                ease: Sine.easeOut
            });
            gsap.to(inner[index],{
                scaleX: 0,
                duration: 0.5,
                delay: index * 0.2 + 0.5,
                ease: Sine.easeOut

            })

        });

    });


})();
